import { clubConfig, setCSSVariables } from './config/club.config';

import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';

setCSSVariables(clubConfig[0]);

bootstrapApplication(AppComponent, appConfig)
.catch(err => console.error(err));
